import { AgsFreespinCelebrationState } from "ags/state-machine/states/ags-freespin-celebration-state";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { AbstractMatrixComponent, DimType } from "slotworks/components/matrix/abstract-matrix-component";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";

export class ThemeFreespinCelebrationState extends AgsFreespinCelebrationState {
    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();

        const matrix = Components.get(AbstractMatrixComponent);
        const allSymbols = Components.get(AbstractMatrixComponent).getBaseGridSymbols();

        // Filter out the freespins won by the trail
        const freespins = record.getResultsOfType(FreespinWinResult).filter((result) => {
            return (
                result.linkedResult instanceof SymbolWinResult &&
                result.linkedResult.symbolType !== "TT"
            );
        });

        if (freespins.length === 0) {
            this.complete();
        } else {
            const isRetrigger = gameState.getCurrentGame().inFreespins();
            if (!isRetrigger) { gameWrapper.enableFeatureMode(); }

            const freespinsWon = freespins[0].freespinsWon;
            const linked = freespins[0].linkedResult;

            const resultToAnimate = linked as SymbolWinResult;
            if (!resultToAnimate) {
                this.complete();
                return;
            }

            const symbolID = resultToAnimate.symbolType;
            const winningSymbols = matrix.getSymbolsFromPositions(resultToAnimate.positions);
            Services.get(SoundService).customEvent("bonus_bell");
            Services.get(SoundService).event(SoundEvent.symbol_ID_celebrate, symbolID);
            Services.get(SoundService).event(SoundEvent.symbol_any_celebrate);

            const hiddenSymbols = matrix.getHiddenSymbols();
            matrix
                .dimSymbols(allSymbols.concat(hiddenSymbols), DimType.Win, resultToAnimate)
                .execute();

            const highlightArray = [];
            record.results.forEach((result) => {
                if(result instanceof SymbolWinResult) {
                    let symbols = matrix.getSymbolsFromPositions((result as SymbolWinResult).positions);
                    highlightArray.push(() => matrix.highlightSymbols(symbols, result as SymbolWinResult));
                }
            });

            highlightArray.push(() => Contract.getTimeoutContract(this.config.minHighlightTime));

            new Parallel(highlightArray).then(() => {
                this.complete();
            });
        }
    }
}
